import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectService } from '@shared/services/project.service';
import { IProject, IProjectReducerState } from '@shared/interfaces/IProject';
import type { IRootState } from './index';

const chosenProject: IProject | undefined = new ProjectService().getChosenProject();

const initialState: IProjectReducerState = {
	workingProject: chosenProject,
	userProjects: [],
};

const projectSlice = createSlice({
	name: 'project',
	initialState,
	reducers: {
		setWorkingProjectSuccess: (
			state: IProjectReducerState,
			action: PayloadAction<{ workingProject: IProject }>
		) => {
			state.workingProject = action.payload.workingProject;
		},
		updateUserProjects: (state: IProjectReducerState, action: PayloadAction<{ userProjects: IProject[] }>) => {
			state.userProjects = action.payload.userProjects;
		},
	},
});

export const selectProject = (state: IRootState): IProject | undefined => state.projectReducer.workingProject;
export const selectProjectId = (state: IRootState): string | undefined =>
	state.projectReducer.workingProject?.projectId;
export const selectTimezone = (state: IRootState): string | undefined => state.projectReducer.workingProject?.tz;
export const selectLanguage = (state: IRootState): string | undefined => state.projectReducer.workingProject?.language;

export const { setWorkingProjectSuccess, updateUserProjects } = projectSlice.actions;
export default projectSlice.reducer;
